"use client";

import React, { useEffect, useState } from 'react'
import Image from "next/image";
import close from '../../public/images/x.svg'
import list from '../../public/images/list.svg'
import Link from 'next/link';
import logo from '../../public/images/logo.webp'


export const ViewPlanPage = () => {


    const [activeFouthCard, setActiveFouthCard] = useState(0);

  // Card data array for easier management
  const Fourthcards = [
    {
      title: "Web + App",
      price: "₹14899",
      isPopular: true,
      features: [
        "Faster Loading",
        "Premium Support & Updates",
        "High-Performance & Security",
        "Transparent Pricing, No Hidden Costs"
      ]
    },
    {
      title: "Website",
      price: "₹4999",
      isPopular: false,
      features: [
        "Faster Loading",
        "Premium Support & Updates",
        "High-Performance & Security",
        "Transparent Pricing, No Hidden Costs"
      ]
    },
    {
      title: "Mobile App",
      price: "₹9999",
      isPopular: false,
      features: [
        "Faster Loading",
        "Premium Support & Updates",
        "High-Performance & Security",
        "Transparent Pricing, No Hidden Costs"
      ]
    }
  ];

    
  return (
    <div>

<section>
  <div className="flex min-h-screen items-center justify-center bg-[#CADCEE] ">
    <div className="w-[988px] h-auto  bg-white sm:rounded-2xl rounded-0 shadow-lg sm:mx-3 mx-0 sm:my-3 my-0">
    <div className='block sm:hidden mt-[16px]'>
        <div className=' justify-center flex'>
         <Image alt="Vilva Business logo" className='cursor-pointer' src={logo}/>
        </div>
      </div>
      <div className="flex justify-between items-center mt-[20px] sm:mt-[0px] p-4 sm:p-5">
        <div>
          <h1 className="text-[#090D28] text-[20px] font-semibold sm:text-[20px]">Plan Details</h1>
          <p className="text-[#090D28] text-[14px] sm:text-sm">No Hidden Charges. GST only.</p>
        </div>
        <Link href="/chooseplan" aria-label="Close and return to plans" className='bg-[#EBEBEB] hidden sm:block rounded-md p-1'>
          <Image alt="Close" className='cursor-pointer' src={close}/>
        </Link>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 '>
      {Fourthcards.map((card, index) => (
        <div 
        key={index}
        onClick={() => setActiveFouthCard(index)}
        className={`
          card relative flex flex-col justify-center items-center m-3 rounded-xl px-4 cursor-pointer
          ${index === activeFouthCard 
            ? 'border-2 border-[#FFE476] bg-gradient-to-b from-[#5CB5F3] to-[#005CE5] scale-[1.002]' 
            : 'border-2 border-white bg-gradient-to-b from-[#6DCFF5] to-[#3697EB]'}
          h-[342px] flex-shrink-0
          hover:scale-[1px] transition-transform duration-200 ease-in-out
        `}
      >
          {card.isPopular && (
            <div className=''>
              <p className='absolute text-[16px] top-0 left-0 bg-[#FFF2BD] text-[#C96915] rounded-tl-xl rounded-br-xl px-2 py-1'>
                Most Popular
              </p>
            </div>
          )}
          <div className='flex flex-col justify-center'>
            <div>
              <p className='py-1 text-center bg-[#458BE5] rounded-2xl text-white text-[16px]'>
                {card.title}
              </p>
            </div>
            <div>
              <p className='text-[36px] font-bold text-white'>
                {card.price}/ <span className='text-[16px] font-normal text-white'>Only</span>
              </p>
            </div>
          </div>
          <div className='flex justify-start'>
            <ul className='space-y-4'>
              {card.features.map((feature, i) => (
                <div key={i} className='flex'>
                  <div className='mr-1'>
                    <Image alt="" className='cursor-pointer' src={list} />
                  </div>
                  <div>
                    <p className='text-white text-[13px]'>{feature}</p>
                  </div>
                </div>
              ))}
              <div>
                <p className='text-[#FFD780] text-[13px]'>GST Charges apply *</p>
              </div>
            </ul>
          </div>
        </div>
      ))}
    </div>


      <div className=' block justify-center items-center md:flex m md:justify-between lg:items-center p-4'>
        {/* <div className='flex justify-center order-1 md:order-2'>
            <button className='bg-[#217DF8] rounded-md w-full cursor-pointer py-3 px-9 text-white '>Create website Now</button>
        </div> */}
        <div className='flex justify-center my-3'>
        <Link href="/chooseplan">
            <p className='text-[16px] underline text-[#217DF8]'>Back to Page</p>
        </Link>
        </div>
      </div>
      <div className='block sm:hidden '>
        <div className=' justify-center flex w-full mx-auto pb-[16px]'>
         <p className='text-[10px] whitespace-nowrap !text-[#090D28]'>© Copyright 2025 <a target='_blank'  className='text-[#1672F1]' href="https://www.vilvabusiness.com/">Vilva Business </a>All Rights Reserved</p>
        </div>
      </div>

    </div>
    
  </div>
</section>

    </div>
  )
}
